// extracted by mini-css-extract-plugin
export default {"itemsGrid":"Projects_itemsGrid__1iqlW"};